// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllocatedPhoneAPIModel
 */
export interface AllocatedPhoneAPIModel {
    /**
     * 
     * @type {string}
     * @memberof AllocatedPhoneAPIModel
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof AllocatedPhoneAPIModel
     */
    token: string;
}

export function AllocatedPhoneAPIModelFromJSON(json: any): AllocatedPhoneAPIModel {
    return AllocatedPhoneAPIModelFromJSONTyped(json, false);
}

export function AllocatedPhoneAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllocatedPhoneAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'token': json['token'],
    };
}

export function AllocatedPhoneAPIModelToJSON(value?: AllocatedPhoneAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
        'token': value.token,
    };
}


